// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4b164e19","453":"07ae0dd4","732":"badd8fd8"}[chunkId] + ".chunk.js";
};